import * as TooltipPrimitive from '@radix-ui/react-tooltip';
import * as React from 'react';
import { Icon } from '@/components/global/Icons';
import classNames from '@/lib/classNames';

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef<React.ElementRef<typeof TooltipPrimitive.Content>, React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>>(
    ({ className, sideOffset = 4, ...props }, ref) => (
        <TooltipPrimitive.Content
            ref={ref}
            sideOffset={sideOffset}
            className={classNames(
                'z-50 overflow-hidden rounded-md bg-white px-3 py-1.5 text-xs text-primary animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2',
                className
            )}
            {...props}
        />
    )
);
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

const FormTooltip = ({ type, content }: { type: 'question' | 'alert'; content: string | React.ReactNode }) => {
    return (
        <TooltipProvider>
            <Tooltip delayDuration={200}>
                <TooltipTrigger
                    onClick={(e) => {
                        e.preventDefault();
                    }}
                    className="bg-sea-blue text-white rounded-full w-4 h-4"
                >
                    <Icon id={type} className="w-4 h-4 fill-white" />
                </TooltipTrigger>
                <TooltipContent className="max-w-[12rem] md:max-w-[16rem] lg:max-w-[18rem]">
                    <div className="pr-3 md:pr-3.5 lg:pr-4 py-1.5">{content}</div>
                    <Icon id={type} className="w-4 h-4 fill-white absolute top-1.5 right-1.5" />
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};
export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider, FormTooltip };
